import { useState } from 'react';
import Hero from './components/Hero';
import Features from './components/Features';
import About from './components/About';
import Quiz from './components/Quiz';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';

export default function HomePage() {
  return (
    <div className="min-h-screen">
      <Hero />
      <Features />
      <About />
      <Quiz />
      <Testimonials />
      <Contact />
    </div>
  );
}
